// extracted by mini-css-extract-plugin
module.exports = {"D_section":"D_D_section__RY9za"};